/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as begin from './ageassurance/begin.js'
export * as defs from './ageassurance/defs.js'
export * as getConfig from './ageassurance/getConfig.js'
export * as getState from './ageassurance/getState.js'
